/*
 * Copyright (C) 2024 Das Land Schleswig-Holstein vertreten durch den
 * Ministerpräsidenten des Landes Schleswig-Holstein
 * Staatskanzlei
 * Abteilung Digitalisierung und zentrales IT-Management der Landesregierung
 *
 * Lizenziert unter der EUPL, Version 1.2 oder - sobald
 * diese von der Europäischen Kommission genehmigt wurden -
 * Folgeversionen der EUPL ("Lizenz");
 * Sie dürfen dieses Werk ausschließlich gemäß
 * dieser Lizenz nutzen.
 * Eine Kopie der Lizenz finden Sie hier:
 *
 * https://joinup.ec.europa.eu/collection/eupl/eupl-text-eupl-12
 *
 * Sofern nicht durch anwendbare Rechtsvorschriften
 * gefordert oder in schriftlicher Form vereinbart, wird
 * die unter der Lizenz verbreitete Software "so wie sie
 * ist", OHNE JEGLICHE GEWÄHRLEISTUNG ODER BEDINGUNGEN -
 * ausdrücklich oder stillschweigend - verbreitet.
 * Die sprachspezifischen Genehmigungen und Beschränkungen
 * unter der Lizenz sind dem Lizenztext zu entnehmen.
 */
import { ZUSTAENDIGE_STELLE_SERVICE, ZustaendigeStelleService } from '@alfa-client/zustaendige-stelle-shared';
import { DIALOG_DATA, DialogRef } from '@angular/cdk/dialog';
import { Component, inject } from '@angular/core';
import { Resource } from '@ngxp/rest';

//TODO rename to SearchZustaendigeStelleDialogContainerComponent
@Component({
  selector: 'search-zustaendige-stelle-dialog',
  templateUrl: './search-zustaendige-stelle-dialog.component.html',
  standalone: false,
})
export class SearchZustaendigeStelleDialogComponent<T extends Resource> {
  private readonly dialogRef = inject(DialogRef);
  private readonly service = inject<ZustaendigeStelleService<T>>(ZUSTAENDIGE_STELLE_SERVICE);
  protected readonly title = inject(DIALOG_DATA);

  public closeDialog(): void {
    this.service.clearSearchResult();
    this.dialogRef.close();
  }

  public searchResultSelected(zustaendigeStelle: T): void {
    this.dialogRef.close(zustaendigeStelle);
  }
}
